import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Popup } from "@/Common/Components/Modals/Popup";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { ColumnConfigurationModel } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import { GridDisplaySettings } from "@/Common/Models/UI/Tables/GridDisplaySettings";
import { TableColumnInfo } from "@/Common/Models/UI/Tables/TableColumnInfo";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { UserSettings } from "@/Globals/Models/UserSettings";

interface IMyleTableColumnOrderPropsv2 {
    TableColumns: ColumnConfigurationModel[];
    ContainerId: string;
    CloseColumOrder?: number;
    SaveOptionskeyTarget: string;
    centeredHorizontally?: boolean;
    altStyles?: React.CSSProperties;
    closeColumnOrderPopup?: () => void;
    dataCy?: string;
}

class MyleTableColumnOrderControlStatev2 {
    public TableColumns: ColumnConfigurationModel[];

    constructor(state?: MyleTableColumnOrderControlStatev2) {
        if (state != null) { this.TableColumns = state.TableColumns; }
        else { this.TableColumns = []; }
    }
}

class MyleTableColumnOrderControlv2 extends BaseReactComponent<IMyleTableColumnOrderPropsv2, MyleTableColumnOrderControlStatev2> {
    constructor(props: IMyleTableColumnOrderPropsv2) {
        super(props);

        const initialState = new MyleTableColumnOrderControlStatev2();
        initialState.TableColumns = this.props.TableColumns;
        this.state = initialState;
    }

    public componentDidMount(): void {
        this.setOverlay("tableColumnOrder", { transparent: false });
    }

    public render(): JSX.Element {
        let self = this;

        let availableColumns = this.state.TableColumns.filter((i: ColumnConfigurationModel) => i.IsHidden === true);
        let displayedColumns = this.state.TableColumns.filter((i: ColumnConfigurationModel) => i.IsHidden === false);

        let availableColumnsRender = (availableColumns.map((col, idx) => {
            let appliedClasses = "multiselectlist-item";

            if (col.IsSelected) { appliedClasses += "-selected"; }

            return <li key={"availableCol_" + idx} onMouseDown={this.preventSelection.bind(this)} className={appliedClasses} onClick={self.onSelectColumn.bind(this, col)}> {col.ColumnText}</li>;
        }));

        let displayedColumnRender = (displayedColumns.map((col, idx) => {
            let appliedClasses = "multiselectlist-item";

            if (col.IsFixedInPlace) { appliedClasses += " locked-column-option"; }

            else if (col.IsSelected) { appliedClasses += "-selected"; }

            return <li className={appliedClasses} key={"displayedCol_" + idx} onMouseDown={this.preventSelection.bind(this)} onClick={self.onSelectColumn.bind(this, col)}> {col.ColumnText}</li>;
        }));

        return (
            <Popup
                closeTarget={self.props.CloseColumOrder}
                cssClass="tbmgr"
                title={cacheStore.GetString("SelectColumnArrangementLabel").toUpperCase()}
                draggable={true}
                centeredHorizontally={this.props.centeredHorizontally}
                onCloseDelegate={() => this.onCloseAction()}
                style={this.props.altStyles}
            >

                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="m-cols clearfix">
                                <div className="col c1">
                                    <div className="p-lb"><label>{cacheStore.GetString("AvailableColumnsLabel")}</label></div>
                                    <ul onMouseDown={this.preventSelection.bind(this)} className="multiselectlist" style={{ overflow: "auto" }} data-cy={this.props.dataCy ? `${this.props.dataCy}-availableColumn` : null}>
                                        {availableColumnsRender}
                                    </ul>
                                </div>
                                <div className="col c2">
                                    <div className="mgr-nav-btns">
                                        <div style={{ marginBottom: "10px" }}>
                                            <button className="btn btn-primary btn-sm" onClick={this.onMoveLeftClick.bind(this)} data-cy={this.props.dataCy ? `${this.props.dataCy}-arrowRight` : null}>
                                                <span className="glyphicon glyphicon-arrow-right" />
                                            </button>
                                        </div>
                                        <div>
                                            <button className="btn btn-primary btn-sm" onClick={this.onMoveRightClick.bind(this)} data-cy={this.props.dataCy ? `${this.props.dataCy}-arrowLeft` : null}>
                                                <span className="glyphicon glyphicon-arrow-left" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col c3">
                                    <div className="p-lb"><label>{cacheStore.GetString("DisplayedColumnsLabel")}</label></div>
                                    <ul onMouseDown={this.preventSelection.bind(this)} className="multiselectlist" style={{ overflow: "auto" }} data-cy={this.props.dataCy ? `${this.props.dataCy}-displayedColumn` : null}>
                                        {displayedColumnRender}
                                    </ul>
                                </div>
                                <div className="col c4">
                                    <div className="mgr-nav-btns">
                                        <div style={{ marginBottom: "10px" }}>
                                            <button className="btn btn-primary btn-sm" onClick={this.onMoveUpClick.bind(this)} data-cy={this.props.dataCy ? `${this.props.dataCy}-arrowUp` : null}>
                                                <span className="glyphicon glyphicon-arrow-up" />
                                            </button>
                                        </div>
                                        <div>
                                            <button className="btn btn-primary btn-sm" onClick={this.onMoveDownClick.bind(this)} data-cy={this.props.dataCy ? `${this.props.dataCy}-arrowDown` : null}>
                                                <span className="glyphicon glyphicon-arrow-down" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 text-right">
                            <button className="btn btn-default push-right-5" onClick={this.onCloseAction.bind(this)}>{cacheStore.GetString("CancelLabel")}</button>
                            <button className="btn btn-primary" onClick={this.onSaveButtonClick.bind(this)} data-cy={this.props.dataCy ? `${this.props.dataCy}-save` : null}>{cacheStore.GetString("SaveLabel")}</button>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private onSaveButtonClick(): void {
        var self = this;

        // New ways of Saving Grid Configs
        let settings = new UserSettings();
        settings.GridsDisplaySettings = [];

        const newGridDisplaySettings = new KeyValuePair<string, GridDisplaySettings>(self.props.SaveOptionskeyTarget, new GridDisplaySettings());
        newGridDisplaySettings.Value.OrderedColumns = [];

        let gridSettingToUpdate: KeyValuePair<string, GridDisplaySettings>[] = [];
        if (cacheStore.UserSettings && cacheStore.UserSettings.GridsDisplaySettings) {
            gridSettingToUpdate = cacheStore.UserSettings.GridsDisplaySettings.filter(x => {
                if (x.Key == self.props.SaveOptionskeyTarget)
                    return true;
            });
        }
        else {
            settings.GridsDisplaySettings = [];
        }

        let columns = this.state.TableColumns;

        for (let column of columns) {
            let t: TableColumnInfo = null;

            if (gridSettingToUpdate != null && gridSettingToUpdate.length > 0) { // If Cache found for this grid, load current column
                const fieldName = column.ColumnUniqueName;
                const cols = gridSettingToUpdate[0].Value.OrderedColumns;
                t = cols.filter(d => d.ColumnName === fieldName)?.[0] ?? null;
            }

            if (t != null) { // Found something in dB Settings for this SaveOptionskeyTarget, Copy its settings and overwrite Hidden Status Only
                t.IsHidden = column.IsHidden;
            }
            else { // Nothing in Database. Just OverWrite Everything...
                t = new TableColumnInfo();
                t.ColumnName = column.ColumnUniqueName;
                t.IsHidden = column.IsHidden;
                t.WidthRatio = column.DefaultWidthRatio;
            }
            newGridDisplaySettings.Value.OrderedColumns.push(t);
        }

        settings.GridsDisplaySettings.push(newGridDisplaySettings); // Only Add the one to Update. Server will manage it and only update this one without touching the others

        // Write to DB
        let client = new Client();
        client.Post(ServerOperations.Server.Myle_UpdateUserSettings, { UserSettings: settings, UserId: sessionStore.userId }, () => self.onCloseAction(), error => console.error(error));

        // UpdateLocal Caches
        for (let i = 0; i < cacheStore.UserSettings?.GridsDisplaySettings?.length; i++) {
            if (cacheStore.UserSettings.GridsDisplaySettings[i].Key != newGridDisplaySettings.Key)
                settings.GridsDisplaySettings.push(cacheStore.UserSettings.GridsDisplaySettings[i]); // Only Add the one to Update. Server will manage it and only update this one without touching the others
        }
        cacheStore.UserSettings.GridsDisplaySettings = settings.GridsDisplaySettings;
    }

    private onCloseAction(): void {
        if (this.props.CloseColumOrder) {
            let operation = new LocalEvent(this.props.CloseColumOrder);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (this.props.closeColumnOrderPopup) {
            this.props.closeColumnOrderPopup();
        }
    }

    private onMoveRightClick(): void {
        this.lateralMove(true);
    }

    private onMoveLeftClick(): void {
        this.lateralMove(false);
    }

    private lateralMove(hide: boolean): void {
        let stateColumns = this.state.TableColumns.map((c: ColumnConfigurationModel) => {
            if (c.IsSelected) { c.IsHidden = hide; }
            return c;
        });

        let s = new MyleTableColumnOrderControlStatev2();
        s.TableColumns = stateColumns;
        this.setState(s);
    }

    private onSelectColumn(column: ColumnConfigurationModel): void {
        if (column.IsFixedInPlace === true) return; // can't select fixed columns

        let stateColumns = this.state.TableColumns.map((c: ColumnConfigurationModel) => {
            c.IsSelected = c.ColumnUniqueName === column.ColumnUniqueName;
            return c;
        });

        let s = new MyleTableColumnOrderControlStatev2();
        s.TableColumns = stateColumns;
        this.setState(s);
    }

    private onMoveUpClick(): void {
        this.move(true);
    }

    private onMoveDownClick(): void {
        this.move(false);
    }

    private move(up: boolean): void {
        let selectedItems = this.state.TableColumns.filter(c => c.IsSelected === true);
        if (selectedItems.length === 0) return;

        let selectedColumn: ColumnConfigurationModel = selectedItems[0];
        if (selectedColumn.IsFixedInPlace === true) return;

        let a = this.state.TableColumns;

        let selectedColumnConverted = a.filter(x => x.ColumnUniqueName === selectedColumn.ColumnUniqueName);

        let model = up ? ArrayHelper.MoveElementUp(a, selectedColumnConverted[0]) : ArrayHelper.MoveElementDown(a, selectedColumnConverted[0]);

        let configModel: ColumnConfigurationModel[] = [];
        for (let column of model) {
            const columnId = column.ColumnUniqueName;
            const columns = this.state.TableColumns;
            const m = columns.filter(x => x.ColumnUniqueName === columnId)?.[0] ?? null;
            if (m != null) {
                m.IsHidden = column.IsHidden;
                configModel.push(m);
            }
        }

        let s = new MyleTableColumnOrderControlStatev2();
        s.TableColumns = configModel;
        this.setState(s);
    }

    private preventSelection(e: React.MouseEvent): void {
        e.preventDefault();
    }
}

export { IMyleTableColumnOrderPropsv2, MyleTableColumnOrderControlv2 };
